<template v-if="listSections" @currentParentPage="currentParentPage($event)" @reloadTable="reloadTable($event)">
  <div class="row">
  <div class="col-12">    
    <table class="table" v-if="$store.state.responsive.viewDesktopLists">
      <thead class="fixheader">
        <tr>
          <th>
            Usuario conf
          </th>
          <th>
            Usuario firma
          </th>
          <th>
            Estado
          </th>
          <th class="thOperaciones"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(section, index) in listSections" :key="index">
          <td class="textoTabla">
            {{ section.userApplication }}
          </td>
          <td class="textoTabla">
            {{ section.userApprove }}
          </td>
          <td class="statusSpace">
            <span
              v-bind:class="{ 'border-success text-success': section.status == 'confirmed', 'border-danger text-danger': section.status == 'denied', 'border-info text-info': section.status == 'pending', 'border-dark text-muted': section.status == 'disabled', }"
              class="badge border text-uppercase">{{ section.status }}</span>
          </td>
          <td id="operaciones" class="align-middle py-4 tdOperaciones">
            <div class="dropdown dropdown-inherit">
              <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <v-icon name="fa-ellipsis-v" />
              </span>
              <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                <a href="#" class="dropdown-item py-3 px-4" data-toggle="modal" data-target="#sectionsDetail" @click="ratingDetail(section.id)">
                  Ver detalle
                </a>
                <a href="#" class="dropdown-item py-3 px-4"
                  @click="confirmSection(section.id)">
                  Confirmar
                </a>
                <a href="#" class="dropdown-item py-3 px-4" @click="deniedSection(section.id)">
                  Denegar
                </a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-if="!$store.state.responsive.viewDesktopLists">
      <div class="card p-2 mb-3" v-for="(section, index) in listSections" :key="index">  
        <div class="list-item">
          <div class="item d-flex align-items-center justify-content-between px-2 py-3" data-toggle="collapse"
            :href="'#collapseExample' + index" role="button" aria-expanded="true"
            :aria-controls="'collapseExample' + index">
            <h4 class="m-0">{{ section.userApplication }}</h4>
            <v-icon name="bi-chevron-up" />
          </div>
          <div class="collapse show ml-3 mr-2 borderFirstItem" :id="'collapseExample' + index">
            <div class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2">
              <div class="d-flex align-items-center justify-content-start">
                <p class="m-0 mr-2"><strong>Usuario conf: </strong>{{ section.userApplication }}</p>
              </div>
              <div>
                <div class="dropdown dropdown-inherit">
                  <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                    <a href="#" class="dropdown-item py-3 px-4" data-toggle="modal" data-target="#sectionsDetail" @click="ratingDetail(section.id)">
                      Ver detalle
                    </a>
                    <a href="#" class="dropdown-item py-3 px-4"
                      @click="confirmSection(section.id)">
                      Confirmar
                    </a>
                    <a href="#" class="dropdown-item py-3 px-4" @click="deniedSection(section.id)">
                      Denegar
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Usuario firma: </strong>{{ section.userApplication }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Estado: </strong></p>
              <span
              v-bind:class="{ 'border-success text-success': section.status == 'confirmed', 'border-danger text-danger': section.status == 'denied', 'border-info text-info': section.status == 'pending', 'border-dark text-muted': section.status == 'disabled', }"
              class="badge border text-uppercase">{{ section.status }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
  </div>
  <SectionsDetail :id="'sectionsDetail'" :modalTitle="'DETALLE DE TRAMOS'" :class="'modal-xl'" :showFooter="false" :indexRating="indexRating">
  </SectionsDetail>
</template>

<script>
import SectionsDetail from './SectionsDetail.vue';
import axios from 'axios';
export default {
  name: 'ListSections',
  props: [
    'sections',
  ],
  data() {
    return {
      from: ['0'],
      to: ['Más'],
      score: ['100'],
      listSections: this.sections,
      itemsPerPage: 25,
      currentPage: 0,
      indexRating: '',
      stateUpdated: false,
      username: this.$cookies.get('username'),
    };
  },
  updated() {
    if (this.stateUpdated === false) {
      this.listSections = this.sections;
    } 
    
    this.stateUpdated = false;
  },
  methods: {
    addInputs(index) {
      if (this.to[index] != 'Más') {
        if (parseInt(this.to[index]) <= parseInt(this.from[index])) {
          this.to[index] = 'Más';
        } else {
          this.from.push((parseInt(this.to[index]) + 1).toString())
          this.to.push('Más')
          this.score.push((parseInt(this.score[index]) + 100).toString())
        }
      }
    },
    cleanSearch() {
      this.from = ['0'];
      this.to = ['Más'];
      this.score = ['100'];
    },
    confirmSection(index) {
      const bodyToSend = {
        id: index,
        status: "confirmed"
      }
      const config = {
        headers: {
          'X-User': this.username,
        }
      };
      axios.patch('/application-product-rating', bodyToSend, config)
        .then(() => {
          axios.get(`/application-product-rating/search?pageNumber=${this.currentPage}&pageSize=${this.itemsPerPage}&sort=%2Bstatus`)
            .then((response) => {
              this.stateUpdated = true;
              this.listSections = response.data.applicationProductRatings;
            });
        });
    },
    deniedSection(index) {
      const bodyToSend = {
        id: index,
        status: "denied"
      }
      const config = {
        headers: {
          'X-User': this.username,
        }
      };
      axios.patch('/application-product-rating', bodyToSend, config)
        .then(() => {
          axios.get(`/application-product-rating/search?pageNumber=${this.currentPage}&pageSize=${this.itemsPerPage}&sort=%2Bstatus`)
            .then((response) => {
              this.stateUpdated = true;
              this.listSections = response.data.applicationProductRatings;
            });
        });
    },
    currentParentPage(item) {
      this.currentPage = item;
    },
    ratingDetail(index){
      this.indexRating = index;
    },
    reloadTable(item) {
      this.listSections = item;
    },
  },
  components: {
    SectionsDetail
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.statusSpace {
  vertical-align: middle;
}
.actionsSuperuser {
  padding-left: 0%;
}

#operaciones {
  text-align: center;
}

.textoTabla {
  vertical-align: middle;
}
</style>
